import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = { type: "", data: null };

const syncReducers = {
  setModalData: (state, { payload }) => {
    return payload;
  },
  clearModalData: () => {
    return INITIAL_STATE;
  },
};

const modal = createSlice({
  name: "modal",
  initialState: INITIAL_STATE,
  reducers: syncReducers,
});

export const { setModalData, clearModalData } = modal.actions;

export default modal.reducer;
